theme.AnnouncementBar = (function() {
  function Announcement(e) {

    // Notification close
    function abToogle() {
      var element = document.getElementById("ab__toggle");
      element.classList.toggle("announcement__bar--toggle");
    }
    document.getElementById("ab__toggle__button").addEventListener('click', abToogle);

    }
  return Announcement;
})();